<template>
	<v-row align="center" justify="center">
		<v-col cols="12" lg="7">
			<v-form @submit.prevent="submit" v-model="valid" ref="form">
				<v-text-field
					v-model="form.password"
					:append-icon="showOld ? 'mdi-eye' : 'mdi-eye-off'"
					:rules="[rules.required, rules.min]"
					:type="showOld ? 'text' : 'password'"
					label="Současné heslo"
					counter
					@click:append="showOld = !showOld"
					:error-messages="errors.password"
				></v-text-field>

				<v-text-field
					v-model="form.new_password"
					:append-icon="showNew ? 'mdi-eye' : 'mdi-eye-off'"
					:rules="[rules.required, rules.min, rules.match]"
					:type="showNew ? 'text' : 'password'"
					label="Nové heslo"
					counter
					@click:append="showNew = !showNew"
					:error-messages="errors.new_password"
				></v-text-field>

				<v-text-field
					v-model="form.new_password_confirmation"
					:append-icon="showNewConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
					:rules="[rules.required, rules.min, rules.match]"
					:type="showNewConfirmation ? 'text' : 'password'"
					label="Nové heslo znovu"
					counter
					@click:append="showNewConfirmation = !showNewConfirmation"
					:error-messages="errors.new_password_confirmation"
				></v-text-field>

				<v-btn color="primary" type="submit" block :loading="form.busy">{{ $t('save') }}</v-btn>
			</v-form>
		</v-col>
		<v-snackbar v-model="form.successful" bottom color="success" left :absolute="false">
			{{ $t('messages.success.save') }}
		</v-snackbar>
	</v-row>
</template>

<script>
import Form from 'vForm'
export default {
	name: 'Password',

	data() {
		return {
			form: new Form({
				password: null,
				new_password: null,
				new_password_confirmation: null
			}),
			valid: true,
			showOld: false,
			showNew: false,
			showNewConfirmation: false,
			rules: {
				required: value => !!value || 'Required.',
				min: v => (v && v.length >= 8) || 'Min 8 characters',
				match: () => this.form.new_password === this.form.new_password_confirmation || 'Password must match'
			},
			errors: {}
		}
	},

	methods: {
		submit() {
			this.valid = this.$refs.form.validate()
			if (this.valid) {
				this.change()
			}
		},
		async change() {
			try {
				await this.form.patch('/barber/profile/password')
				this.form.reset()
				this.$refs.form.reset()
				this.$refs.form.resetValidation()
			} catch ({ response }) {
				this.errors = response.data.errors
			}
		}
	}
}
</script>
